/**
 * Bootstrap default group ID→name mapping for the Invision Community forum at
 * nexus.eotir.com.  Populated from the authoritative group catalog in
 * `C:\eotir\projects\invision_groups_all.md`.
 *
 * This constant is always available at build time with zero network dependency
 * (per D-01).  The admin-side KV `group-map` key supersedes it at runtime when
 * a refresh has been performed, but the bootstrap default guarantees that every
 * known group ID resolves to a human-readable name regardless of KV state.
 *
 * Type: `Record<string, string>` where keys are numeric group IDs as strings
 * (per D-09) and values are the exact display names from the Invision ACP.
 */
export const DEFAULT_GROUP_MAP: Record<string, string> = Object.freeze({
  '2': 'Guests',
  '3': 'New Players',
  '4': '+Lead Admin',
  '6': 'High Council',
  '7': 'Armed Forces',
  '9': 'Intelligence',
  '10': 'Government Officials',
  '12': 'Special Operations',
  '13': 'Fringe',
  '14': 'Security Bureau',
  '17': 'The DCC',
  '23': 'Force Users',
  '24': 'HMPS',
  '28': 'Research & Development',
  '30': 'COMPNOR Operatives',
  '31': 'Royal Family',
  '32': 'Retired Members',
  '38': '+Admin',
  '40': '##Dead Characters##',
  '45': '+Staff',
  '47': 'Royal Guard',
  '48': 'Armed Forces Command',
  '50': 'House Stratus',
  '51': 'High Judicate',
  '52': 'Players',
  '53': 'Players (Experienced)',
  '54': 'Throne Chambers Access',
  '55': '-Throne-',
  '56': '*C.A.T.',
  '57': '*S.M.A.R.T.',
  '58': '*F.A.T.E.',
  '59': '*P.A.R.T.',
  '60': '*O.O.P.S.',
  '61': '*Limited TEMP ACP',
  '62': 'Praetorian',
  '63': '+Senior Admin',
  '64': 'Honorary Staff',
  '65': 'Hapan Government',
  '66': '+Tech Support',
  '68': 'Moderators',
  '69': '##Bad Emails##',
});
